import { isEqual } from 'lodash'
import { POST } from '@/api'

const INITIAL_OPTION = {
  id: null,
  label: null,
  inputType: null,
  length: null,
  items: [],
  itemsLastKey: 0,
}

/**
 * 顧客情報追加項目
 */
export default {
  namespaced: true,
  state: {
    option: { ...INITIAL_OPTION },
    busy: false,
  },
  mutations: {
    set(state, option) {
      state.option = { ...INITIAL_OPTION, ...option }
    },
    update(state, option) {
      state.option = { ...state.option, ...option }
    },
    addItem(state) {
      state.option.items = state.option.items.concat({ name: '' })
    },
    updateItemName(state, { index, name }) {
      state.option.items.splice(index, 1, { ...state.option.items[index], name })
    },
    deleteItem(state, index) {
      state.option.items = state.option.items.filter((_, i) => i !== index)
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    origin: ({ option }, _, { customers }) =>
      option.id
        ? customers.options.byId[option.id]
        : { label: null, inputFormat: option.inputType === 5 ? { '-1': 0 } : 100 },
    inputFormat: ({ option }) => {
      const { inputType, length, items } = option
      if (inputType === 5) {
        let lastKey = option.itemsLastKey
        const itemMap = items.reduce(
          (inputFormat, item) =>
            item.name ? Object.assign(inputFormat, { [item.key || ++lastKey]: item.name }) : inputFormat,
          {},
        )
        return { ...itemMap, '-1': lastKey }
      }
      return length
    },
    changed: ({ option }, { inputFormat, origin }) =>
      option.label !== origin.label || !isEqual(inputFormat, origin.inputFormat),
  },
  actions: {
    async start({ commit, rootState }, { id, inputType }) {
      if (id) {
        const { inputFormat, ...option } = rootState.customers.options.byId[id]
        commit('set', {
          ...option,
          length: option.inputType === 1 ? inputFormat : null,
          items:
            option.inputType === 5
              ? Object.keys(inputFormat)
                  .filter(key => key > 0)
                  .map(key => ({ key: +key, name: inputFormat[key] }))
              : [],
          itemsLastKey: inputFormat[-1] || 0,
        })
      } else {
        commit('set', { inputType, length: inputType === 1 ? 100 : null, items: [{}, {}] })
      }
    },
    async save({ commit, state, getters }) {
      if (state.busy) return false
      commit('busy', true)

      const { id, label, inputType } = state.option
      const { status, message } = await POST('/api/web/option/customer/regist', {
        id,
        label,
        inputType,
        inputFormat: getters.inputFormat,
      })
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },
  },
}
